import { faSpinnerScale } from '@awesome.me/kit-4a6bf60416/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { cn } from '@/lib/utils';

interface ImageGenerationSpinnerProps {
  className?: string;
}

export function ImageGenerationSpinner({ className }: ImageGenerationSpinnerProps) {
  return (
    <FontAwesomeIcon
      icon={faSpinnerScale}
      className={cn('animate-spin text-[96px] text-primary [animation-duration:1.2s]', className)}
    />
  );
}

interface ImageGenerationLoaderProps {
  imageUrl?: string | null;
  imageAlt?: string;
  className?: string;
  overlayClassName?: string;
  spinnerClassName?: string;
}

export function ImageGenerationLoader({
  imageUrl,
  imageAlt = '',
  className,
  overlayClassName,
  spinnerClassName,
}: ImageGenerationLoaderProps) {
  return (
    <section
      className={cn('relative overflow-hidden bg-muted', className)}
      aria-busy="true"
      aria-live="polite"
      aria-label="Generating image"
    >
      {imageUrl && (
        <img src={imageUrl} alt={imageAlt} className="absolute inset-0 size-full object-cover" />
      )}
      <div className={cn('absolute inset-0 bg-background/80', overlayClassName)} />
      <div className="absolute inset-0 flex items-center justify-center">
        <ImageGenerationSpinner className={spinnerClassName} />
      </div>
    </section>
  );
}
